module.exports = __webpack_public_path__ + "img/014-quick-1.dde13ffa.svg";